
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { EcaSecurityAuthenticationService } from './../../services/security-authentication/security-authentication.service';
import { EcaApiGatewayService } from './../../services/api-gateway/api-gateway.service';
import { EcaEnvironmentService } from './../../services/environment/environment.service';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AsyncPipe, JsonPipe } from '@angular/common';

@Component({
    selector: 'eca-authenticated-landing',
    templateUrl: './authenticated-landing.component.html',
    styleUrls: ['./authenticated-landing.component.css'],
    imports: [RouterLink, AsyncPipe, JsonPipe]
})
export class AuthenticatedLandingComponent implements OnInit {
  private _ecaEnvironmentService = inject(EcaEnvironmentService);
  private _ecaApiGatewayService = inject(EcaApiGatewayService);
  private _ecaSecurityAuthenticationService = inject(EcaSecurityAuthenticationService);


  name: string;
  securityServiceUrl: string;
  user: Observable<any>;
  isAuthenticated: Observable<any>;

  ngOnInit() {
    this.name = this._ecaEnvironmentService.json['name'];
    this.securityServiceUrl = this._ecaApiGatewayService.lookup('eca-security-service');
    this.isAuthenticated = this._ecaSecurityAuthenticationService.isAuthenticated();
    this.user = this._ecaSecurityAuthenticationService.getUser().pipe(
      catchError(() => observableOf(false)));
  }
}
